export default "__VITE_ASSET__C5vDS4og__"